module.exports = __webpack_public_path__ + "img/left_arrow_ash_icon.d41fe8c4.svg";